import reportingApi from '../services/reporting.api';
import {LoadingState} from './constants';

const getChatOverviewEventCount = (state, eventName) => {
  if (state.chatOverview.state === LoadingState.LOADED) {
    const engagements = state.chatOverview.data.find(element => element.EVENT_NAME === eventName);
    if (engagements) {
      return engagements.RESULT;
    }
  }
  return 0;
};

export default {
  namespaced: true,
  state: {
    chatEnabled: {
      state: LoadingState.EMPTY,
      data: true,
    },
    chatOverview: {
      state: LoadingState.EMPTY,
      data: [],
    },
    chatLeads: {
      state: LoadingState.EMPTY,
      data: [],
    },
    monthlyPerformance: {
      state: LoadingState.EMPTY,
      data: {
        currentMonth: [],
        pastThreeMonths: [],
      },
    },
    agentActivity: {
      state: LoadingState.EMPTY,
      data: [],
    },
    csmNotes: {
      state: LoadingState.EMPTY,
      data: [],
    },
    chatSystemScore: {
      state: LoadingState.EMPTY,
      data: {},
    },
    whizeoHealthScore: {
      state: LoadingState.EMPTY,
      data: {},
    },
  },
  mutations: {
    updateChatEnabled(state, enabled) {
      state.chatEnabled = enabled;
    },
    updateChatOverview(state, payload) {
      state.chatOverview = {
        ...state.chatOverview,
        ...payload,
      };
    },
    updateChatLeads(state, payload) {
      state.chatLeads = {
        ...state.chatLeads,
        ...payload,
      };
    },
    updateMonthlyPerformance(state, payload) {
      state.monthlyPerformance = {
        ...state.monthlyPerformance,
        ...payload,
      };
    },
    updateAgentActivity(state, payload) {
      state.agentActivity = {
        ...state.agentActivity,
        ...payload,
      };
    },
    updateCsmNotes(state, payload) {
      state.csmNotes = {
        ...state.csmNotes,
        ...payload,
      };
    },
    updateChatSystemScore(state, payload) {
      state.chatSystemScore = {
        ...state.chatSystemScore,
        ...payload,
      };
    },
    updateWhizeoHealthScore(state, payload) {
      state.whizeoHealthScore = {
        ...state.whizeoHealthScore,
        ...payload,
      };
    },
    addNote(state, note) {
      state.csmNotes.data.unshift(note);
    },
  },
  getters: {
    impressions(state) {
      return getChatOverviewEventCount(state, 'chat_icon_shown');
    },
    engagements(state) {
      return getChatOverviewEventCount(state, 'chat_engaged');
    },
  },
  actions: {
    async fetchOverview({state, commit}, {clientId, startDate, endDate}) {
      commit('updateChatOverview', {state: LoadingState.LOADING});
      try {
        const chatOverview = await reportingApi.getChatOverview(clientId, startDate, endDate);
        commit('updateChatOverview', {state: LoadingState.LOADED, data: chatOverview});
        const chat = getChatOverviewEventCount(state, 'chat_icon_shown');
        commit('updateChatEnabled', chat > 0);
      } catch (error) {
        commit('updateChatOverview', {state: LoadingState.FAILED});
      }
    },
    async fetchLeads({commit}, {clientId, startDate, endDate}) {
      commit('updateChatLeads', {state: LoadingState.LOADING});
      try {
        const chatLeads = await reportingApi.getChatLeads(clientId, startDate, endDate);
        commit('updateChatLeads', {state: LoadingState.LOADED, data: chatLeads});
      } catch (error) {
        commit('updateChatLeads', {state: LoadingState.FAILED});
      }
    },
    async fetchAgentActivity({commit}, {clientId}) {
      commit('updateAgentActivity', {state: LoadingState.LOADING});
      try {
        const agentActivity = await reportingApi.getAgentActivity(clientId);
        commit('updateAgentActivity', {state: LoadingState.LOADED, data: agentActivity});
      } catch (error) {
        commit('updateAgentActivity', {state: LoadingState.FAILED});
      }
    },
    async fetchMonthlyPerformance({commit}, {clientId}) {
      commit('updateMonthlyPerformance', {state: LoadingState.LOADING});
      try {
        const monthlyPerformance = await reportingApi.getMonthlyPerformance(clientId);
        commit('updateMonthlyPerformance', {
          state: LoadingState.LOADED,
          data: monthlyPerformance,
        });
      } catch (error) {
        commit('updateMonthlyPerformance', {state: LoadingState.FAILED});
      }
    },
    async fetchCsmNotes({commit}, {clientId}) {
      commit('updateCsmNotes', {state: LoadingState.LOADING});
      try {
        const notes = await reportingApi.getNotesByClientId(clientId);
        commit('updateCsmNotes', {state: LoadingState.LOADED, data: notes});
      } catch (error) {
        commit('updateCsmNotes', {state: LoadingState.FAILED});
      }
    },
    async fetchChatSystemScore({commit}, {clientId}) {
      commit('updateChatSystemScore', {state: LoadingState.LOADING});
      try {
        const notes = await reportingApi.getSystemScoreByClientId(clientId);
        commit('updateChatSystemScore', {state: LoadingState.LOADED, data: notes});
      } catch (error) {
        commit('updateChatSystemScore', {state: LoadingState.FAILED});
      }
    },
    async fetchWhizeoHealthScore({commit}, {clientId}) {
      commit('updateWhizeoHealthScore', {state: LoadingState.LOADING});
      try {
        const notes = await reportingApi.getClientLatestHealthScore(clientId);
        commit('updateWhizeoHealthScore', {state: LoadingState.LOADED, data: notes});
      } catch (error) {
        commit('updateWhizeoHealthScore', {state: LoadingState.FAILED});
      }
    },
    async addCsmNote({commit}, note) {
      commit('addNote', note);
    },
  },
};
